
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"a",attrs:{"cx":"12","cy":"7.5","r":"3"}}),_c('path',{staticClass:"a",attrs:{"d":"M12 .75a6.75 6.75 0 016.75 6.75c0 3.251-5.132 10.527-6.446 12.337a.377.377 0 01-.608 0C10.382 18.027 5.25 10.751 5.25 7.5A6.75 6.75 0 0112 .75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M17.979 17.784c2.732.541 4.521 1.444 4.521 2.466 0 1.657-4.7 3-10.5 3s-10.5-1.343-10.5-3c0-1.02 1.781-1.921 4.5-2.463"}})])
          )
        }
      }
    